
let key = {};
let EnvName = null;
let IPFS_IMG = "https://ipfs.infura.io/ipfs"
var networkVersion=''
var BNBProvider="";
let Back_Url=""
let decimalValues = 1000000000000000000;
let toasterOption = {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
}

if(window.location.href.indexOf("local") !== -1){
    EnvName = 'local';
}else{
    EnvName = 'production';
}

if (EnvName === "demo") {
    var exchangeAddress = "0x08aF65036535b0a90F65c395bd6811b9f1E9a0A4";
    var adminaddress = "";
    var singleContract="0x9d01c0efd118d90f0b964c3C659f036D9467B267";
    var multipleContract="0x9d01c0efd118d90f0b964c3C659f036D9467B267";
    var API_URL = 'https://endpoint.nft-ascii.com';
    var IMAGE_URL = 'https://endpoint.nft-ascii.com/images/user';
    var PORT = 2053;
    networkVersion='97';
    BNBProvider="https://data-seed-prebsc-1-s1.binance.org:8545/";
    Back_Url='http://192.53.121.26:2053'
}
 else if(EnvName === "production") {
    var exchangeAddress = "";
    var adminaddress = "";
    var singleContract="0x9d01c0efd118d90f0b964c3C659f036D9467B267";
    var multipleContract="0x9d01c0efd118d90f0b964c3C659f036D9467B267";
    var API_URL = 'https://endpoint.nft-ascii.com';
    var IMAGE_URL = 'https://endpoint.nft-ascii.com/images/user';
    var PORT = 2053;
    networkVersion='56';
    Back_Url='https://endpoint.nft-ascii.com';
    BNBProvider="https://bsc-dataseed1.binance.org";
    var Front_URL="https://admin-pi-green.vercel.app/nftasciiadmin"
    
}
else if(EnvName === "local") {
    var exchangeAddress = "";
    var adminaddress = "";
    var singleContract="0x9d01c0efd118d90f0b964c3C659f036D9467B267";
    var multipleContract="0x9d01c0efd118d90f0b964c3C659f036D9467B267";
    var API_URL = 'http://localhost';
    var IMAGE_URL = 'http://localhost:2010/images/user';
    var PORT = 2010;
    Back_Url='http://localhost:2010'
    networkVersion='97';
    BNBProvider="https://data-seed-prebsc-1-s1.binance.org:8545/";
    var Front_URL="http://localhost:3000/nftasciiadmin"
}

console.log('debug', EnvName);

key = {
    secretOrKey: "",
    Recaptchakey: "",
    API:`${API_URL}:${EnvName === 'production' ? '' : PORT }/v1`,
    //API:`${API_URL}/v1`,
    IMAGE_URL:IMAGE_URL,
    exchangeAddress:exchangeAddress,
    toasterOption:toasterOption,
    IPFS_IMG:IPFS_IMG,
    networkVersion:networkVersion,
    adminaddress:adminaddress,
    decimalValues:decimalValues,
    Back_Url:Back_Url,
    singleContract:singleContract,
    multipleContract:multipleContract,
    networkVersion:networkVersion,
    BNBProvider:BNBProvider,
    Front_URL:Front_URL
};

export default key;